const main = async (): Promise<void> => {
    const { default: lazySizes } = await import('lazysizes');
    lazySizes.init();
};

void main();
